import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { AppSettings } from './service/settings/app-settings.service';
import { CommonModule, Location } from '@angular/common';
import { HeaderComponent } from './components/core-template/header/header.component';
import { SidebarComponent } from './components/core-template/sidebar/sidebar.component';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { UserService } from '@services/core/user.service';
import { StorageService } from '@services/core/storage.service';
import Swal from 'sweetalert2'
import { AppVariablesService } from './service/app-variables.service';
import { ThemePanelComponent } from './components/core-template/theme-panel/theme-panel.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, SidebarComponent,ThemePanelComponent, CommonModule],
  providers: [MicrosoftAuthService, UserService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit{
  @Input() code?: any
  title = 'pres.Ui';
  isLogged: any 
  authMicrosoft = inject(MicrosoftAuthService)
  activatedRoute = inject(ActivatedRoute)
  userService = inject(UserService)
  location = inject(Location)
  router = inject(Router)
  storageService = inject(StorageService)
  swalBackground: any
	swalTextColor: any
  constructor( private appVariablesService: AppVariablesService,
              public appSettings: AppSettings
  ) {}

  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  appVariables = this.appVariablesService.getAppVariables()


		
  ngOnInit() {
    this.swalDarkMode()
    this.isLogged = this.storageService.getJsonValue("logged");

    if (this.isLogged == null) {
      this.handleNotLoggedIn();
    } else {
      this.handleLoggedIn();
    }


    if (this.appSettings.appDarkMode) {
			this.onAppDarkModeChanged(false);
		}
	
		if (localStorage) {
			if (localStorage['appDarkMode']) {
				this.appSettings.appDarkMode = localStorage['appDarkMode'];
				if (this.appSettings.appDarkMode) {
					this.onAppDarkModeChanged(true);
				}
			}
			if (localStorage['appGradientEnabled']) {
				this.appSettings.appGradientEnabled = (localStorage['appGradientEnabled'] === 'true') ? true : false;
			}
		}
  }
  
  private handleNotLoggedIn() {
    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      if (params["code"]) {
        this.getToken(params["code"]);
      } else {
        this.loginMicrosoft();
      }
    });
  }
  
  private handleLoggedIn() {
  
  const path = this.location.path().includes("?code") ? "" : this.location.path()
  this.router.navigateByUrl(path);
  this.getUserData();
  }

  // set page minified
	onAppSidebarMinifiedToggled(val: any): void {
		this.appSettings.appSidebarMinified = !this.appSettings.appSidebarMinified;
		if (localStorage) {
			localStorage['appSidebarMinified'] = this.appSettings.appSidebarMinified;
		}
	}

  onAppDarkModeChanged(val: boolean): void {

   	if (localStorage['appDarkMode'] === 'true') {  
      this.appSettings.appDarkMode=true;      
			document.documentElement.setAttribute('data-bs-theme', 'dark');
		} else {
			document.documentElement.removeAttribute('data-bs-theme');
      this.appSettings.appDarkMode=false; 
		}
    this.appSettings.appDarkMode
    this.appSettings.appGradientEnabled = (localStorage['appGradientEnabled'] === 'true') ? true : false;
		this.appVariables = this.appVariablesService.getAppVariables();
		this.appVariablesService.variablesReload.emit();
		document.dispatchEvent(new CustomEvent('theme-change'));
	}
	
  // hide mobile sidebar
  onAppSidebarMobileToggled(val: any): void {
    this.appSettings.appSidebarMobileToggled = !this.appSettings.appSidebarMobileToggled;
  }

  loginMicrosoft() {
    this.authMicrosoft.getTokenAPI().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      window.location.href = res.url;
    });
	}

  private handleLoginError(err: any) {
    console.warn('Error al obtener el token:', err);
    Swal.fire({
      title: 'Error de autenticación',
      text: err.error?.msg || err.error?.message || err.message || 'No se pudo canjear el código de Microsoft',
      icon: 'error',
      confirmButtonText: 'Reintentar'
    }).then(() => { window.location.href = '/'; });
  }

  getToken(code: string) {
      this.authMicrosoft.getAccessToken(code).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: res => {
        this.setCookie("access_token", res.access_token)
				this.authMicrosoft.token.set(res.access_token)
				this.authMicrosoft.refreshToken.set(res.refresh_token);
        this.storageService.setJsonValue("logged", "true")
        this.storageService.setJsonValue("token", res.access_token)
        this.storageService.setJsonValue("refresh_token", res.refresh_token)
        if(this.router.url.includes("?code") ){
          const path = this.router.url.split("?")[0]
          this.router.navigateByUrl(path) 
        } 
				this.getUserData();
			},
			error: err => this.handleLoginError(err)
		});
	}

  getUserData() {
    this.swalDarkMode()
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      background: this.swalBackground,
			color:this.swalTextColor,
		
      willOpen: () => {
        Swal.showLoading();
      },
    });
    this.authMicrosoft.decryptToken().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: res => {
      if (res.error) {
        
          Swal.fire({
            title: "Acceso Denegado",
            text: res.error,
            icon: "error",
            background: this.swalBackground,
			      color:this.swalTextColor,			
            confirmButtonText: "Salir",
            allowOutsideClick: false
          }).then(result => {
            this.authMicrosoft.logout().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
                next: (res) => {
                  this.authMicrosoft.clearSesion()
                  const url = res?.url || (typeof res === 'string' ? res : null)
                  window.location.href = url || '/'
                },
                error: () => { window.location.href = '/' }
              })
          })
       
      } else {
        try {
          if (res.sessionToken) {
            this.authMicrosoft.setSessionToken(res.sessionToken);
          }
          this.userService.processUserData(res.user.user);
          this.userService.processUserPhoto(res.photo?.body?.data);
          this.userService.sharingEntities.set(res.user.entities);
          this.userService.sharingEntity.set(res.user.entity);
          this.userService.sharingIdentity.set(res.user.identity);
          this.userService.sharingMenu.set(res.user.menu);
          this.userService.sharingRole.set(res.user.role);
          this.isLogged = this.authMicrosoft.token;
          this.cdr.markForCheck()
        } catch (error) {
          console.warn('Error en el procesamiento de datos:', error);
        }

        Swal.close()

        }

		},
		error: err => {
			Swal.close();
			// 401 lo gestiona ValidTokenInterceptor ("Sesión Expirada")
			if (err.status === 401) return;
			Swal.fire({
				title: 'Error al validar sesión',
				text: err.error?.msg || err.error?.message || err.message || 'Sin respuesta del servidor (revise red/CORS)',
				icon: 'error',
				confirmButtonText: 'Reintentar'
			}).then(() => { window.location.href = '/'; });
		}
		})
	}


  swalDarkMode(){	
		if(localStorage['appDarkMode'] === 'true'){
			this.swalBackground= '#333';
			this.swalTextColor='#fff';
		}
		else{			
			this.swalBackground='#fff';
			this.swalTextColor='#333';
		}
	}

	
  private setCookie(name: string, value: string, days?: number) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; secure; SameSite=Strict";
  }


}
